import { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import styles from './AdminSettingsPaperless.module.scss';
import { adminGetFetchSettings, adminUpdateSettings } from '../actions/adminAction';
import { getAdminFetchSettings } from '../selectors/adminSelectors';

interface IAdminSettingsPaperlessStoreProps {
  settings: IAdminSetting[];
}

const AdminSettingsPaperlessWithoutStore = ({ settings }: IAdminSettingsPaperlessStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isEnablePaperlessSetting = settings?.find(
    setting => setting.code === AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_ACT_PRESCRIPTION,
  );

  const [isEnablePaperless, setIsEnablePaperless] = useState(isEnablePaperlessSetting?.value === 'true');

  useEffect(() => {
    dispatch(adminGetFetchSettings());
  }, [dispatch]);

  useEffect(() => {
    setIsEnablePaperless(isEnablePaperlessSetting?.value === 'true');
  }, [settings]);

  const onCheckboxChange = useCallback(() => {
    setIsEnablePaperless(!isEnablePaperless);
  }, [isEnablePaperless]);

  const onSave = useCallback(() => {
    if (!isEnablePaperlessSetting) return;

    dispatch(
      adminUpdateSettings(
        {
          ...isEnablePaperlessSetting,
          value: isEnablePaperless ? 'true' : 'false',
        },
        isEnablePaperlessSetting.id,
      ),
    );
  }, [isEnablePaperless]);

  return (
    <div className={styles.Wrapper}>
      <div className="shared-section-title">Включение безбумажного функционала</div>
      <Checkbox
        id={'isEnablePaperlessCheckbox'}
        theme="system"
        onChange={onCheckboxChange}
        checked={isEnablePaperless}
        label={'Активация безбумажного формата акта и предписания'}
        className={styles.CheckBox}
      />
      <Button color="primary" variant="contained" text="Сохранить изменения" onClick={onSave} />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IAdminSettingsPaperlessStoreProps => ({
  settings: getAdminFetchSettings(state),
});

export const AdminSettingsPaperless = connect(mapStateToProps)(AdminSettingsPaperlessWithoutStore);
